<template>
   <div class="sub">{{data}}</div> 
</template>
<script>
export default {
    props: {
        data: String,
    }   
}
</script>

<style lang="stylus" scoped>

@import "~styl/mixin.styl"
.sub 
    fs(20)

</style>


// WEBPACK FOOTER //
// src/components/business/sub.vue